'use client';
import { Amplify } from 'aws-amplify';
import outputs from '@/amplify_outputs.json';

Amplify.configure(outputs, { ssr: true });

export default function ConfigureAmplifyClientSide() {
  return null;
}


// METHOD for running locally:

// "use client";

// import { useEffect } from "react";
// import { Amplify } from "aws-amplify";
// import outputs from "@/amplify_outputs.json";
// import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";
// import { CookieStorage } from "aws-amplify/utils";

// export default function ConfigureAmplifyClientSide() {
//   useEffect(() => {
//     // Guard against double-run in React 18 dev & route transitions
//     if (typeof window !== "undefined" && (window as any).__amplifyConfigured) return;
//     (window as any).__amplifyConfigured = true;

//     // 1) Configure Amplify
//     Amplify.configure(outputs, { ssr: true });

//     // 2) Store tokens in cookies so SSR can see them
//     const isProd = process.env.NODE_ENV === "production";
//     cognitoUserPoolsTokenProvider.setKeyValueStorage(
//       new CookieStorage({
//         // IMPORTANT: leave domain undefined on localhost
//         domain: isProd ? process.env.NEXT_PUBLIC_WEBSITE_URL : undefined,
//         path: "/",
//         // On localhost, you must NOT set SameSite:'none' (requires secure)
//         sameSite: isProd ? "none" : "lax",
//         secure: isProd,          // must be true if sameSite:'none'
//         expires: 7,              // days
//       })
//     );
//   }, []);

//   return null;
// }